import CryptoJS from "crypto-js";
import { getExternalSystem } from "./partner";

/**
 * Encrypts a claim number and external system identifier using AES encryption
 * @param {string} claimNumber - The claim number to encrypt
 * @returns {string} The encrypted string
 * @throws {Error} If required parameters are missing or invalid
 */
export function encryptClaimNumber(claimNumber) {
  // Input validation
  if (!claimNumber || typeof claimNumber !== "number") {
    throw new Error("Valid claim number is required");
  }

  try {
    // Get encryption key from environment variable
    const password = "GoodiIntegration2021!";
    const key = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(password));

    // Get IV from environment variable
    const ivHex = "4976616e204d65647665646576558798";
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const payload = JSON.stringify({
      ClaimNumber: claimNumber,
      ExternalSystem: getExternalSystem(),
    });

    const encrypted = CryptoJS.AES.encrypt(payload, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  } catch (error) {
    throw new Error(`Encryption failed: ${error.message}`);
  }
}
